var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.72,
    height: 22,
    viewBox: "0 0 18.72 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M714 2018.63a5.79 5.79 0 0 1-2.11-4.47v-2.511a6.542 6.542 0 0 0-5.731-6.433v-1.9a.876.876 0 0 0-.88-.865.883.883 0 0 0-.621.253.853.853 0 0 0-.259.612v1.9a6.539 6.539 0 0 0-5.727 6.431v2.511a5.793 5.793 0 0 1-2.121 4.477 1.754 1.754 0 0 0-.629 1.342 1.786 1.786 0 0 0 1.8 1.769h4.055a3.625 3.625 0 0 0 3.507 2.7 3.622 3.622 0 0 0 3.513-2.7h4.053a1.8 1.8 0 0 0 1.373-.628 1.747 1.747 0 0 0-.223-2.488zm-3.876-6.982v2.511a7.565 7.565 0 0 0 2.75 5.819.036.036 0 0 1-.035.037h-15.121c-.021 0-.037-.016-.024-.062a7.506 7.506 0 0 0 2.736-5.794v-2.511a4.848 4.848 0 0 1 9.695 0zm-3.207 10.1a1.867 1.867 0 0 1-3.276 0z",
    transform: "translate(-695.919 -2002.449)",
    style: {
      fill: "#254089"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiIcon);
export default __webpack_public_path__ + "static/media/noti-icon.c409a5d5bc2d92eb7a1b30f23c2b008c.svg";
export { ForwardRef as ReactComponent };